<template xmlns="http://www.w3.org/1999/html">
  <div>
    <v-card-text>
      <v-row class="py-2">
        <v-col cols="12" md="3">
          <span class="font-weight-bold">ID:</span> {{ tdata.id || '-' }}
        </v-col>
        <v-col cols="12" md="4">
          <span class="font-weight-bold">Ensembl Protein:</span> {{ tdata.harm_protein || '-' }}
        </v-col>
        <v-col cols="12" md="4">
          <span class="font-weight-bold">PTM Type:</span> {{ $mycommon.capitalizeFirstLetter(tdata.ptm_type) || '-' }}
        </v-col>
      </v-row>

      <v-row class="py-2">
        <v-col cols="12" md="3" class="font-weight-bold">Evidence Source:</v-col>
        <v-col cols="12" md="9">
          <div class="d-flex flex-wrap">
            <v-chip
                v-if="tdata.text_evidence"
                :color="$store.state.textEvidenceColor"
                outlined
                small
                class="ma-1"
                @click="$emit('switch-tab', 'text_mining')"
            >
              Text mining ({{ tdata.text_evidence }})
            </v-chip>
            <v-chip
                v-if="tdata.figure_evidence"
                :color="$store.state.figureEvidenceColor"
                outlined
                small
                class="ma-1"
                @click="$emit('switch-tab', 'figure')"
            >
              Figure mining ({{ tdata.figure_evidence }})
            </v-chip>
            <v-chip
                v-if="tdata.experiment"
                :color="$store.state.experimentEvidenceColor"
                outlined
                small
                class="ma-1"
                @click="$emit('switch-tab', 'experiment')"
            >
              PTMAtlas datasets ({{ tdata.experiment }})
            </v-chip>
            <v-chip
                v-if="tdata.cohort"
                :color="$store.state.cohortEvidenceColor"
                outlined
                small
                class="ma-1"
                @click="$emit('switch-tab', 'cptac_abundance')"
            >
              CPTAC datasets ({{ tdata.cohort }})
            </v-chip>
          </div>
        </v-col>
      </v-row>

      <v-row class="py-2">
        <v-col cols="12" md="3" class="font-weight-bold">
          Evidence Score:
          <helpicon
              tooltip-text="The publication score reflects the number of text/figure mining evidences, hallmark associations, supporting PMC articles, and co-mentioned diseases.
The data score considers experimental identifications, significant PTM correlations, and PTMsigDB hallmark support."
          />
        </v-col>
        <v-col cols="12" md="9">
          <div><span class="font-weight-medium">Publication score:</span> {{ Number(tdata.publication_score).toFixed(3) }}</div>
          <div><span class="font-weight-medium">Data score:</span> {{ Number(tdata.data_score).toFixed(3) }}</div>
        </v-col>
      </v-row>


      <!-- GPT Summary -->
      <v-row v-if="tdata.sentence_based_summary !== ''">
        <v-col cols="12" md="3"><span class="font-weight-bold">GPT Sentence Summary (LLM self-assessed confidence): <helpicon tooltip-text="GPT summary using sentence from textmining sentences."></helpicon></span></v-col>
        <v-col cols="12" md="9">{{ tdata.sentence_based_summary ? (tdata.sentence_based_summary.trim() + (tdata.sentence_confidence_score ? " (" + tdata.sentence_confidence_score + ")" : "")) : "None" }}</v-col>
      </v-row >

      <v-row  v-if="tdata.ptmsigdb_signature !== ''">

        <v-col cols="12" md="3"><span class="font-weight-bold">PTMsigDB Signature:</span></v-col>
        <v-col cols="12" md="9">
          <div v-if="displayedItems.length > 0">
            <ul style="columns: 2; -webkit-columns: 2; column-gap: 2rem;">
              <li v-for="(item, index) in displayedItems" :key="index" >
                <a
                    href="https://proteogenomics.shinyapps.io/ptmsigdb/ptmsigdb.Rmd"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                  {{ item}}
                </a>

              </li>
            </ul>
            <div v-if="splitItems.length > 6" class="mt-2">
              <v-btn x-small text outlined @click="showAll = !showAll">
                {{ showAll ? 'Show Less' : 'Show More' }}
                <v-icon small>{{ showAll ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn>
            </div>
          </div>

          <div v-else >None</div>
        </v-col>

      </v-row>

      <v-row  v-if="hoc && Object.keys(hoc).length > 0">
        <v-col cols="12" md="3">
            <span class="font-weight-bold">
              Hallmark Process (Values in parentheses represent Publications/Sentences, click to show detailed evidence)
              <helpicon tooltip-text="Hallmark is predicted from text-mining sentences using BioLinkBERT. Hover to see number of supporting sentences; click to view detailed evidence for this hallmark"></helpicon>
            </span>
        </v-col>
        <v-col cols="12" md="9">

            <hallmark-donut
                :protein-id="tdata.id"
                :hallmark-values="hoc"
                @hallmark-click="fetchCancerHallmark"
            />

                      <v-sheet outlined
                          v-if="showHallmarkTable"
                          style="max-height: 400px; min-height: 200px; overflow-y: auto;"
                      >
                        <v-sheet class="pa-2" v-if="showHallmarkTable && lastHallmarkKey">
                          <span class="font-weight-bold">Selected Hallmark: </span>

                          <router-link
                              v-if="isHallmarkInSignature"
                              :to="{ path: '/signature', query: { name: lastHallmarkKey } }"
                              target="_blank"
                              class="signature-link"
                          >
                            {{ lastHallmarkKey }}
                          </router-link>

                          <span v-else>
                            {{ lastHallmarkKey }}
                          </span>
                          <span v-if="hoc?.[lastHallmarkKey]">
                            ({{ hoc[lastHallmarkKey].publication }} publications,
                             {{ hoc[lastHallmarkKey].sentence }} sentences)
                          </span>

                        </v-sheet>

                        <v-data-table
                            :headers="hallmarkHeaders"
                            :items="hallmarkTable"
                            dense
                            fixed-header
                            class="my-4"
                            outlined
                        >
                          <template v-slot:item.pub_id="{ item }">
                            <a
                                :href="getPubLink(item.pub_id)"
                                target="_blank"
                            >
                              {{ item.pub_id }}
                            </a>
                          </template>
                        </v-data-table>
                        {{hallmarkTable}}
                      </v-sheet>

        </v-col>
      </v-row>

      <v-row
          v-for="key in Object.keys(typeMap).filter(k =>  k === 'cofigure')"
          :key="key"
          v-if="signature[key] && signature[key].length > 0"
          class="mb-4"
      >
        <v-col cols="12" md="3">
           <span class="font-weight-bold">
            {{ typeMap[key].label }}
            <helpicon :tooltip-text="typeMap[key].tooltip" />
          </span>
        </v-col>
        <v-col cols="12" md="9">
          <ul class="signature-list">
            <li
                v-for="(item, index) in getDisplayedItems(key)"
                :key="key + '_' + index"
            >
              <router-link
                  :to="{ path: '/signature', query: { name: typeof item === 'object' ? item.signature_name : item } }"
                  target="_blank"
                  class="signature-link"
              >
                {{ typeof item === 'object' ? item.original_name : stripPrefix(item) }}
              </router-link>
            </li>

          </ul>

          <div v-if="signature[key].length > limit" class="mt-2">
            <v-btn
                x-small text outlined
                @click="toggleShowAll(key)"
            >
              {{ showAllMap[key] ? 'Show Less' : 'Show More' }}
              <v-icon small>
                {{ showAllMap[key] ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
              </v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>


      <!--comention table-->
      <v-row v-if="Object.keys(disease).length > 0 || Object.keys(cellline ).length > 0 || Object.keys(chemical).length > 0 || Object.keys(gene).length > 0" >
        <v-col cols="12" md="3">
          <span class="font-weight-bold">
            Comentioned with Disease, Gene, Cellline, Chemical evidence (Values in parentheses represent Publications/Sentences, click to show detailed evidence):
            <helpicon tooltip-text="Co-mention between the site and diseases, cell lines, or chemicals. Click to explore supporting details." />
          </span>
        </v-col>
        <v-col cols="12" md="9">
          <v-simple-table dense class="mt-1 custom-table">
            <thead>
            <tr>
              <th style="width: 20%">Category</th>
              <th style="width: 80%">Detail</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Disease</td>
              <td>
                <template v-if="Object.keys(disease || {}).length > 0">
                  <div class="chip-container">
                    <v-chip
                        v-for="([key, value], index) in getLimited(sortedDisease, showAllDisease)"
                        :key="'d_' + key"
                        small
                        outlined
                        class="ma-1"
                        @click="handleComentionClick('disease', key)"
                    >
                      {{ key }} ({{ value['publication'] }}/{{ value['sentence'] }})
                    </v-chip>
                  </div>
                  <v-btn
                      class="my-2"
                      outlined
                      x-small
                      v-if="Object.entries(disease || {}).length > 10"
                      @click="showAllDisease = !showAllDisease"
                  >
                    {{ showAllDisease ? 'Show Less' : 'Show More' }}
                  </v-btn>
                </template>
                <template v-else>-</template>
              </td>
            </tr>

            <tr>
              <td>Gene</td>
              <td>
                <template v-if="Object.keys(gene || {}).length > 0">
                  <div class="chip-container">
                    <v-chip
                        v-for="([key, value], index) in getLimited(sortedGene, showAllGene)"
                        :key="'g_' + key"
                        small
                        outlined
                        class="ma-1"
                        @click="handleComentionClick('gene', key)"
                    >
                      {{ key }} ({{ value['publication'] }}/{{ value['sentence'] }})
                    </v-chip>
                  </div>
                  <v-btn
                      class="my-2"
                      outlined
                      x-small
                      v-if="Object.entries(gene || {}).length > 10"
                      @click="showAllGene = !showAllGene"
                  >
                    {{ showAllGene ? 'Show Less' : 'Show More' }}
                  </v-btn>
                </template>
                <template v-else>-</template>
              </td>
            </tr>

            <tr>
              <td>Cellline</td>
              <td>
                <template v-if="Object.keys(cellline || {}).length > 0">
                  <div class="chip-container">
                    <v-chip
                        v-for="([key, value], index) in getLimited(sortedCellline, showAllCellline)"
                        :key="'l_' + key"
                        small
                        outlined
                        class="ma-1"
                        @click="handleComentionClick('cellline', key)"
                    >
                      {{ key }} ({{ value['publication'] }}/{{ value['sentence'] }})
                    </v-chip>
                  </div>
                  <v-btn
                      class="my-2"
                      outlined
                      x-small
                      v-if="Object.entries(cellline || {}).length > 10"
                      @click="showAllCellline = !showAllCellline"
                  >
                    {{ showAllCellline ? 'Show Less' : 'Show More' }}
                  </v-btn>
                </template>
                <template v-else>-</template>
              </td>
            </tr>
            <tr>
              <td>Chemical</td>
              <td>
                <template v-if="Object.keys(chemical || {}).length > 0">
                  <div class="chip-container">
                    <v-chip
                        v-for="([key, value], index) in getLimited(sortedChemical, showAllChemical)"
                        :key="'c_' + key"
                        small
                        outlined
                        class="ma-1"
                        @click="handleComentionClick('chemical', key)"
                    >
                      {{ key }} ({{ value['publication'] }}/{{ value['sentence'] }})
                    </v-chip>
                  </div>
                  <v-btn
                      class="my-2"
                      outlined
                      x-small
                      v-if="Object.entries(chemical || {}).length > 10"
                      @click="showAllChemical = !showAllChemical"
                  >
                    {{ showAllChemical ? 'Show Less' : 'Show More' }}
                  </v-btn>
                </template>
                <template v-else>-</template>
              </td>
            </tr>
            </tbody>
          </v-simple-table>
          <v-sheet
              class="my-2"
              outlined
              ref="comentionDetail"
              v-if="activeComentionType && showComentionTable && getCurrentTable().length > 0"
              style="max-height: 300px; overflow-y: auto;"
          >
            <v-sheet class="pa-2" v-if="showComentionTable && lastComentionKey && lastComentionType">
              <span class="font-weight-bold">Selected {{ lastComentionType }}:</span>

              <router-link
                  v-if="selectedComentionLink"
                  :to="{ path: '/signature', query: { name: selectedComentionLink } }"
                  target="_blank"
                  class="signature-link"
              >
                {{ lastComentionKey }}
              </router-link>

              <span v-else>
    {{ lastComentionKey }}
  </span>

              <span
                  v-if="getCurrentComentionValue()"
              >
  ({{ getCurrentComentionValue().publication }} publications,
   {{ getCurrentComentionValue().sentence }} sentences)
</span>
            </v-sheet>


            <v-data-table
                :headers="hallmarkHeaders"
                :items="getCurrentTable()"
                class="mt-4"
                dense
                outlined
            >
              <template v-slot:item.sentence="{ item }">
                <span v-html="highlightSentence(item.sentence, item.index_range)"></span>
              </template>

              <template v-slot:item.pub_id="{ item }">
                <a
                    :href="getPubLink(item.pub_id)"
                    target="_blank"
                >
                  {{ item.pub_id }}
                </a>
              </template>
            </v-data-table>
          </v-sheet>
        </v-col>
      </v-row>


    </v-card-text>
  </div>
</template>

<script>
import Axios from "axios";
import HallmarkDonut from "@/components/HallmarkDonut.vue";
import Helpicon from "@/components/sub/helpicon.vue";
import {apiprefix} from "@/main";

export default {
  name: "DetailBasicInfo",
  components: {Helpicon, HallmarkDonut},
  props: ["tdata", "hoc", "chemical", "cellline", "disease",'gene','signature'],
  data() {
    return {
      showAll: false,
      showAllHoc: false,
      showAllDisease: false,
      showAllChemical: false,
      showAllCellline: false,
      showAllGene: false,
      showHallmarkTable: false,
      lastHallmarkKey: null,
      hallmarkTable: [],
      showComentionTable: false,
      lastComentionKey: null,
      lastComentionType: null,
      comentionTableDisease: [],
      comentionTableChemical: [],
      comentionTableCellline: [],
      comentionTableGene: [],
      activeComentionType: "",
      highlightTerm: "",
      hallmarkHeaders: [
        { text: "PMID", value: "pub_id", width: "120px" },
        { text: "Sentence", value: "sentence" },
        { text: "Passage Type", value: "passage_type", width: "140px" }
      ],
      limit: 6,
      showAllMap: {},
      typeMap: {
        cofigure: {
          label: "Figure Signature:",
          tooltip: "The figure signature was generated by using GPT to summarize the figure title. Each signature contains at least 5 phosphosite sites. Click to see sites in the corresponding signature."
        },
        cogene: {
          label: "Comentioned Gene Signature:",
          tooltip: "The gene signature was generated based on the co-occurrence of sites and genes within the same sentence. A valid gene signature requires at least 5 phosphosite sites, and each site must be supported by at least two independent PMIDs. Click to see sites in the corresponding signature."
        },
        codisease: {
          label: "Comentioned Disease Signature:",
          tooltip: "\n" +
              "The disease signature was generated based on the co-occurrence of sites and diseases within the same sentence. A valid disease signature requires at least 5 phosphosite sites, and each site must be supported by at least two independent PMIDs. Click to see sites in the corresponding signature."
        },
        cochemical: {
          label: "Comentioned Chemical Signature:",
          tooltip: "\n" +
              "The chemical signature was generated based on the co-occurrence of sites and chemicals within the same sentence. A valid chemical signature requires at least 5 phosphosite sites, and each site must be supported by at least two independent PMIDs. Click to see sites in the corresponding signature."
        },
        cancerhallmark: {
          label: "Cancer Hallmark Signature:",
          tooltip: "The cancer hallmark signature was generated by classifying literature sentences into one or more cancer hallmark categories using BioLinkBERT. Each signature requires at least 5 phosphosite sites, and each site must be supported by at least two independent PMIDs. Click to see sites in the corresponding signature."
        }
      },
    };
  },
  methods: {
    getPubLink(pub_id) {
      if (!pub_id) return "#"

      const idStr = String(pub_id)

      if (idStr.startsWith("PMC")) {
        return `https://pmc.ncbi.nlm.nih.gov/articles/${idStr}/`
      } else {
        return `https://pubmed.ncbi.nlm.nih.gov/${idStr}/`
      }
    },
    getCurrentComentionValue() {
      if (!this.lastComentionType || !this.lastComentionKey) return null;

      const map = {
        disease: this.disease,
        chemical: this.chemical,
        cellline: this.cellline,
        gene: this.gene
      };

      return map[this.lastComentionType]?.[this.lastComentionKey] || null;
    },
    stripPrefix(name) {
      return name.replace(/^PTMax[^._]*[._]/, '');
    },
    highlightSentence(sentence, indexRange) {
      if (typeof sentence !== 'string') {
        if (sentence === null || sentence === undefined) return "";
        sentence = String(sentence);
      }

      if (!indexRange) return sentence;

      const ranges = indexRange
          .split(';')
          .map(r => r.split('-').map(n => parseInt(n, 10)))
          .filter(([start, end]) => !isNaN(start) && !isNaN(end) && start < end);
      ranges.sort((a, b) => b[0] - a[0]);

      for (const [start, end] of ranges) {
        if (start >= 0 && end <= sentence.length) {
          sentence =
              sentence.slice(0, start) +
              '<span style="color:red;">' +
              sentence.slice(start, end) +
              '</span>' +
              sentence.slice(end);
        }
      }

      return sentence;
    },
    getCurrentTable() {
      if (this.activeComentionType === 'disease') return this.comentionTableDisease;
      if (this.activeComentionType === 'chemical') return this.comentionTableChemical;
      if (this.activeComentionType === 'cellline') return this.comentionTableCellline;
      if (this.activeComentionType === 'gene') return this.comentionTableGene;
      return [];
    },
    async fetchCancerHallmark(hallmarkKey) {
      if (this.lastHallmarkKey === hallmarkKey) {
        this.showHallmarkTable = !this.showHallmarkTable;
        return;
      }

      this.lastHallmarkKey = hallmarkKey;
      this.showHallmarkTable = false;
      this.hallmarkTable = [];

      try {
        const res = await Axios.post(`${apiprefix}/api/detail_cancerhallmark_persite/`, {}, {
          params: {
            select_id: this.tdata.internal_id,
            select_type: this.tdata.ptm_type,
            cancerhallmark: encodeURIComponent(hallmarkKey)
          }
        });

        const data = res.data?.data?.data || [];

        if (data.length > 0) {
          this.hallmarkTable = data;
          this.showHallmarkTable = true;
        } else {
          this.showHallmarkTable = false;
        }
      } catch (err) {
        console.error("Failed to fetch hallmark detail", err);
        this.hallmarkTable = [];
        this.showHallmarkTable = false;
      }
    },

    getLimited(list, showAll) {
      return showAll ? list : list.slice(0, 10);
    },
    async handleComentionClick(type, key) {
      if (this.lastComentionKey === key && this.lastComentionType === type) {
        this.showComentionTable = !this.showComentionTable;
        return;
      }

      this.lastComentionKey = key;
      this.lastComentionType = type;
      this.activeComentionType = type;
      this.highlightTerm = key;
      this.showComentionTable = false;

      try {
        const res = await Axios.post(`${apiprefix}/api/detail_comention_persite/`, {}, {
          params: {
            select_id: this.tdata.internal_id,
            select_type: this.tdata.ptm_type,
            comention_type: type,
            comention_term: encodeURIComponent(key)
          }
        });

        const data = res.data?.data?.data || [];

        if (type === 'disease') this.comentionTableDisease = data;
        if (type === 'chemical') this.comentionTableChemical = data;
        if (type === 'cellline') this.comentionTableCellline = data;
        if (type === 'gene') this.comentionTableGene = data;

        this.showComentionTable = data.length > 0;

        this.$nextTick(() => {
          const el = this.$refs.comentionDetail;
          if (el && el.$el) {
            el.$el.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        });

      } catch (err) {
        console.error(`Failed to fetch ${type} detail`, err);
        this.showComentionTable = false;
      }
    },
    getDisplayedItems(key) {
      const items = this.signature[key] || [];
      if (this.showAllMap[key]) return items;
      return items.slice(0, this.limit);
    },
    toggleShowAll(key) {
      this.$set(this.showAllMap, key, !this.showAllMap[key]);
    },
    normalizeTerm(s) {
      if (!s) return "";
      return s
          .toString()
          .toLowerCase()
          .trim()
          .replace(/[_-]+/g, " ")
          .replace(/\s+/g, " ");
    },
  },
  computed: {
    displayedItems() {
      return this.showAll ? this.splitItems : this.splitItems.slice(0, 6);
    },
    splitItems() {
      return this.tdata?.ptmsigdb_signature?.split(';').map(s => s.trim()).filter(Boolean) || [];
    },
    sortedDisease() {
      const entries = Object.entries(this.disease || {}).sort((a, b) => {
        const pubA = a[1]?.publication || 0;
        const pubB = b[1]?.publication || 0;
        return pubB !== pubA ? pubB - pubA : a[0].localeCompare(b[0]);
      });
      return this.showAllDisease ? entries : entries.slice(0, 10);
    },
    sortedChemical() {
      const entries = Object.entries(this.chemical || {}).sort((a, b) => {
        const pubA = a[1]?.publication || 0;
        const pubB = b[1]?.publication || 0;
        return pubB !== pubA ? pubB - pubA : a[0].localeCompare(b[0]);
      });
      return this.showAllChemical ? entries : entries.slice(0, 10);
    },
    sortedCellline() {
      const entries = Object.entries(this.cellline || {}).sort((a, b) => {
        const pubA = a[1]?.publication || 0;
        const pubB = b[1]?.publication || 0;
        return pubB !== pubA ? pubB - pubA : a[0].localeCompare(b[0]);
      });
      return this.showAllCellline ? entries : entries.slice(0, 10);
    },
    sortedGene() {
      const entries = Object.entries(this.gene || {}).sort((a, b) => {
        const pubA = a[1]?.publication || 0;
        const pubB = b[1]?.publication || 0;
        return pubB !== pubA ? pubB - pubA : a[0].localeCompare(b[0]);
      });
      return this.showAllGene ? entries : entries.slice(0, 10);
    },

    selectedComentionLink() {
      const COMENTION_TO_SIGNATURE_TYPE = {
        gene: "cogene",
        disease: "codisease",
        chemical: "cochemical",
        cellline: null
      };

      const rawType = this.lastComentionType;
      const key = this.lastComentionKey;

      if (!rawType || !key) return null;

      const sigType = COMENTION_TO_SIGNATURE_TYPE[rawType];
      if (!sigType) return null;

      const sig = this.signature?.[sigType];
      if (!sig || sig.length === 0) return null;

      if (sigType === "cogene") {
        return sig.includes(key) ? key : null;
      }

      if (sigType === "codisease" || sigType === "cochemical") {
        const hit = sig.find(item => item.original_name === key);
        return hit ? hit.signature_name : null;
      }

      return null;
    },
    isHallmarkInSignature() {
      const list = this.signature?.["cancerhallmark"] || [];
      if (!this.lastHallmarkKey) return false;
      return list.includes(this.lastHallmarkKey);
    },
  }
};
</script>

<style scoped>
.custom-table thead tr th {
  border-top: 1px solid black !important;
  border-bottom: 1px solid black !important;
}

.custom-table tbody tr:last-child td {
  border-bottom: 1px solid black !important;
}


.chip-container {
  display: flex;
  flex-wrap: wrap;
}

.signature-list {
  columns: 3;
  -webkit-columns: 2;
  column-gap: 2rem;
}

.signature-list li {
  word-wrap: break-word;
  word-break: break-all;
  margin-bottom: 4px;
}

.signature-list a {
  display: inline-block;
  max-width: 100%;
  text-decoration: none;
  color: #1976d2;
}


</style>
